import { WishListDocument } from '../../queries/WishList.gql'
import { useQuery } from './useQuery'

const useWishlist = () => {
  const queryResult = useQuery(WishListDocument)

  return queryResult
}

export default useWishlist
